import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from '../';
import { IGet, IPost } from '../authorization';
import { IAdminActionCenterCompliance, IAdminActionCenterOther, IAdminActionCenterToDo, IAdminNotification } from '@nkr/models/index';

export interface IAdminActionCenterToDoResponse {
    data: {
        success: boolean,
        message: string,
        results: IAdminActionCenterToDo
    }
}

export interface IAdminActionCenterComplianceResponse {
    data: {
        success: boolean,
        message: string,
        results: IAdminActionCenterCompliance
    }
}

export interface IAdminActionCenterOtherResponse {
    data: {
        success: boolean,
        message: string,
        results: IAdminActionCenterOther
    }
}

export interface IAdminNotificationListResponse {
    data: {
        success: boolean,
        message: string,
        results: IAdminNotification[]
    }
}

export interface IAdminNotificationResponse {
    data: {
        success: boolean,
        message: string,
        results: IAdminNotification
    }
}

export const ActionCreators = {
    getNotifications: () => async (dispatch: Dispatch<IApplicationState>): Promise<IAdminNotificationListResponse> => {
        let config: IGet = {
            url: __API__ + '/notification/admin'
        };

        return await dispatch(AuthActionCreators.apiGet(config));
    },
    getNotification: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IAdminNotificationResponse> => {
        let config: IGet = {
            url: `${__API__}/notification/admin/${id}`
        };

        return await dispatch(AuthActionCreators.apiGet(config));
    },
    getToDoItems: () => async (dispatch: Dispatch<IApplicationState>): Promise<IAdminActionCenterToDoResponse> => {
        let config: IGet = {
            url: __API__ + '/admin/action-center/to-do'
        };

        return await dispatch(AuthActionCreators.apiGet(config));
    },
    getComplianceItems: () => async (dispatch: Dispatch<IApplicationState>): Promise<IAdminActionCenterComplianceResponse> => {
        let config: IGet = {
            url: __API__ + '/admin/action-center/compliance'
        };

        return await dispatch(AuthActionCreators.apiGet(config));
    },
    getOtherItems: () => async (dispatch: Dispatch<IApplicationState>): Promise<IAdminActionCenterOtherResponse> => {
        let config: IGet = {
            url: __API__ + '/admin/action-center/other'
        };

        return await dispatch(AuthActionCreators.apiGet(config));
    },
    getMatchOffers: () => async (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        let config: IGet = {
            url: __API__ + '/admin/action-center/match-offers'
        };

        return await dispatch(AuthActionCreators.apiGet(config));
    },
    getDonorClearance: () => async (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        let config: IGet = {
            url: __API__ + '/admin/action-center/donor-clearance'
        };

        return await dispatch(AuthActionCreators.apiGet(config));
    },
    getPreselectsOutstanding: () => async (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        let config: IGet = {
            url: __API__ + '/admin/action-center/preselects-outstanding'
        };

        return await dispatch(AuthActionCreators.apiGet(config));
    },
    getRequestsForDonorReview: () => async (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        let config: IGet = {
            url: __API__ + '/admin/action-center/requests-for-donor-review'
        };

        return await dispatch(AuthActionCreators.apiGet(config));
    },
    getXmResultsDue: (date: string) => async (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        let config: IGet = {
            url: __API__ + '/admin/action-center/xm-results-due' + encodeURI('?sd=' + date)
        };

        return await dispatch(AuthActionCreators.apiGet(config));
    },
    getConfirmReimbursementDonations: () => async (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        let config: IGet = {
            url: __API__ + '/admin/action-center/confirm-reimbursement-donations'
        };

        return await dispatch(AuthActionCreators.apiGet(config));
    },
    getMissingVoucherHolders: () => async (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        let config: IGet = {
            url: __API__ + '/admin/action-center/missing-voucher-holders'
        };

        return await dispatch(AuthActionCreators.apiGet(config));
    },
    getFlaggedForVoucherDonation: () => async (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        let config: IGet = {
            url: __API__ + '/admin/action-center/flagged-for-voucher-donation'
        };

        return await dispatch(AuthActionCreators.apiGet(config));
    },
    getAbWaitlistPatients: () => async (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        let config: IGet = {
            url: __API__ + '/admin/action-center/ab-waitlist-patients'
        };

        return await dispatch(AuthActionCreators.apiGet(config));
    },
    getDashToDo: () => async (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        let config: IGet = {
            url: __API__ + '/admin/action-center/dash-to-do'
        };

        return await dispatch(AuthActionCreators.apiGet(config));
    },
    getDonorsMissingLdPriorization: () => async (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        let config: IGet = {
            url: __API__ + '/admin/action-center/donors-missing-ld-priorization'
        };

        return await dispatch(AuthActionCreators.apiGet(config));
    },
    getPendingPatientIntakeReferrals: () => async (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        let config: IGet = {
            url: __API__ + '/admin/action-center/pending-patient-intake-referrals'
        };

        return await dispatch(AuthActionCreators.apiGet(config));
    },
    markNotificationRead: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        let config: IPost = {
            url: __API__ + '/notification/admin/' + id + '/mark-read'
        };

        return await dispatch(AuthActionCreators.apiPost(config));
    }
}